import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from './../services/auth.service';

import categories from '../../assets/data/cats.json';
import products from '../../assets/data/products.json';
import { Router, ActivatedRoute } from '@angular/router';

import { CommonDataService } from '../services/common-data.service';
import { CommerceDataService } from '../services/commerce-data.service';
import { environment } from '../../environments/environment';
import { first } from 'rxjs/operators';

declare var $:any;

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit, OnDestroy  {

 cats = categories;
 prods = products;
 loggedIn;
 subscription;
 cartItemsSubscription;
 authDetailsSubscription;

 cartItems = []
 numberOfItems = 0

 //calculated from the commerce data service
 cartTotalBreakDown

  modelData: any;
  avatar:any;
  points = 0;
  firstname
  lastname
  isSeller = false

  constructor(private authService: AuthService, private _data: CommonDataService, private _ecomm: CommerceDataService, private router: Router) { 
    this.loggedIn = this.authService.isUserLoggedIn();
    
    let sessionUser = sessionStorage.getItem('BNFGSHGFGG');
    if (sessionUser && sessionUser == 'TYHH50545HSJSJ21FFSDGSFFFSBHSFVSTVS410045') {
        // logged in so return true
        this.isSeller = true
    }

  	console.log(this.loggedIn);
  }

  ngOnInit() {

    if(this.loggedIn) {
      this._data.getProfile() 
      .pipe(first())
      .subscribe(
        data => {
          this.modelData = data['cover']['model']['modelData']['formFieldsEntities'];
  
          this.firstname = data['cover']['model']['modelData']['formFieldsEntities']['first_name'];
          this.lastname = data['cover']['model']['modelData']['formFieldsEntities']['last_name'];
  
          this.avatar = data['cover']['model']['modelData']['formFieldsEntities']['avatar'][0]['tmp_name'];
  
          if(data['cover']['model']['modelData']['formFieldsEntities']['points'])
            this.points = data['cover']['model']['modelData']['formFieldsEntities']['points'];
        },
        error => {},
        () => {}
      );
    }

   

    let cartItems = localStorage.getItem("cartItems")
    
    if(cartItems) {
      this.cartItems = JSON.parse(localStorage.getItem("cartItems"))
      this.numberOfItems = this.cartItems.length
    }

    this.cartTotalBreakDown = this._ecomm.calculateCartTotal()

    console.log(this.cartTotalBreakDown);

    //lets create a subscription of 
    this.subscription = this._data.queryParamsChanged.subscribe(
      (data) => {
        this._data.queryParams = data;
      }
    );

    //Subscribe to the cart items changes and update this cart items every time there is new updates
    this.cartItemsSubscription = this._ecomm.cartItemsChanged.subscribe(
      (data) => {
        this.cartItems = data;
        console.log(this.cartItems)
        this.numberOfItems = this.cartItems.length
        this.cartTotalBreakDown = this._ecomm.calculateCartTotal()
      }
    );

    this.authDetailsSubscription = this.authService.authDetailsChanged.subscribe(
      (data) => {
          let sessionUser = sessionStorage.getItem('BNFGSHGFGG');
          if (sessionUser && sessionUser == 'TYHH50545HSJSJ21FFSDGSFFFSBHSFVSTVS410045') {
              // logged in so return true
              this.isSeller = true
          }

          this.loggedIn = this.authService.isUserLoggedIn();
      }
    );

    //$('#initialise-page').trigger('click');
    $('#loader').hide();

  	console.log(categories);
  	console.log(products);
  }

  searchSite(searchTerm) {
    this.router.navigate(['/search/'+searchTerm]);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getProductImageSrc(modelData){

    if( modelData['files'] && modelData['files']['uploads'] && Array.isArray(modelData['files']['uploads']) && modelData['files']['uploads'].length > 0) {
      let productImages = modelData['files']['uploads']

      for (let index = 0; index < productImages.length; index++) {
        let element = productImages[index];

        if(element['tmp_name'] && element['tmp_name'] != '') {
          let srcStrings = element['tmp_name'].split("public/");
          let src = environment.filesSrc+'/'+srcStrings[1]
          element['src'] = src
          return src
        }
        
      }

    }

      return ''
  }

}
